;(function($, window, document, ntApp) {
	window.ntApp = ntApp;

	ntApp.$win = $(window);
	ntApp.$doc = $(document);

	ntApp.init = function() {
		this.initSliders();
		this.animateSection();
		this.scrollTo();
		this.manageNav();
		this.openDiscountPopup();
		this.customRanger();
		this.videoPopup();
	};

	/**
	 * Init Sliders
	 */
	ntApp.initSliders = function() {
		var introSlider = new Swiper ('.slider--intro .swiper-container', {
			loop: true,
			speed: 700,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			pagination: '.swiper-pagination',
			paginationClickable: true
		 });

		// select the target node
		var target = $('#insta-feed')[0];

		// create an observer instance
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				$('.slider--instagram img').wrap('<div class="swiper-slide"></div>');

				var instagramSlider = new Swiper ('.slider--instagram .swiper-container', {
					slidesPerView: 'auto',
					spaceBetween: 18,
					scrollbar: '.swiper-scrollbar',
					scrollbarDraggable: true
				});

				// later, you can stop observing
				observer.disconnect();
			});
		});

		// configuration of the observer:
		var config = { childList: true };

		// pass in the target node, as well as the observer options
		observer.observe(target, config);

		var awardsSlider = new Swiper ('.slider--awards .swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 70,
			scrollbar: '.swiper-scrollbar',
			scrollbarDraggable: true
		});

		var thumbSlider = new Swiper ('.slider--thumbnail .swiper-container', {
			autoHeight: true
		});

		$('.slider__thumbnails a').on('click', function(event) {
			thumbSlider.slideTo($(this).data('index'));

			event.preventDefault();
		})
	};

	/**
	 * JS Section Animate
	 */
	ntApp.animateSection = function () {
		ntApp.$win.on('scroll load', function() {
			$('.js-animate').each(function (){
				var sectionAnimate = $(this).offset().top - ntApp.$win.height() * 0.7;

				if ( ntApp.$win.scrollTop() >= sectionAnimate) {
					$(this).addClass('animate');
				}
			});
		});
	};

	/**
	 * Animated scroll to a section for a duration
	 *
	 * @param  {Number}   position Position on the page
	 * @param  {Number}   speed    Duration of the animation in miliseconds
	 * @param  {Function} callback Function to run when the animation completes
	 */
	ntApp.animateScrollTo = function(position, speed, callback) {
		$('html, body').animate({
			scrollTop: position
		}, speed, callback);
	};

	/**
	 * Click to scroll to a section
	 */
	ntApp.scrollTo = function() {
		$('.scroll-top').on('click', function(event) {

			var $section = $( $(this).attr('href') );
			var position = $section.offset().top;

			ntApp.animateScrollTo(position, 750);

			event.preventDefault();
		});
	};

	ntApp.manageNav = function() {
		$('.btn-menu').on('click', function(event) {
			$('.header .header__inner').slideToggle();
			$('.nav').slideToggle();

			event.preventDefault();
		})
	}

	ntApp.openDiscountPopup = function() {
		if ( $('body').hasClass('template-cart') ) {
			this.discountPopup();
		}
	}

	ntApp.discountPopup = function() {
		if ( !Cookies.get('agechecker') || Cookies.get('discount') ) { return; }

		$.magnificPopup.open({
			items: {
				src: '.popup-discount',
				type:'inline'
			}
		});

		$('.popup-discount form').on('submit' , function(event) {
			Cookies.set('discount', true, { expires: 365, path: '/' });

			$.magnificPopup.close();
		});
	}

	ntApp.videoPopup = function() {
		$('.section__video a').magnificPopup({
			type:'iframe'
		});
	}

	ntApp.customRanger = function() {
		var stepSlider = $('#range')[0];

		if (stepSlider == undefined) return;

		noUiSlider.create(stepSlider, {
			start: [0],
			step: 1,
			range: {
				'min': [0],
				'max': [11]
			}
		});
	}


})(jQuery, window, document, window.ntApp || {});

;(function(ntApp) {
	ntApp.$doc.ready(function() {
		ntApp.init();
	});

})(window.ntApp || {});
